import { render } from "./Product.vue?vue&type=template&id=22accdac"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=22accdac&lang=css"
script.render = render

export default script